import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Time_Log_Entry } from '@Util/Types';
import { get_reported_working_hours_summary } from '@Util/Utils';

interface Startpage_Total_Time_Header_Props {
    todays_time_log: Time_Log_Entry[];
    weeks_time_log: Time_Log_Entry[];
}

export default function Startpage_Total_Time_Header(props: Startpage_Total_Time_Header_Props): JSX.Element {
    const [t] = useTranslation();

    const todays_active_hours = useMemo(
        () => get_reported_working_hours_summary(props.todays_time_log),
        [props.todays_time_log]
    );

    const weeks_active_hours = useMemo(
        () => get_reported_working_hours_summary(props.weeks_time_log),
        [props.weeks_time_log]
    );

    return (
        <header className="Module_Header Module_Header--Startpage">
            <h2 className="Headline2">
                {t('Text.Today')} - {todays_active_hours?.detailed?.length >= 1
                    ? `${todays_active_hours.detailed} (${todays_active_hours.overview} h)`
                    : "0 timmar"}
            </h2>
            {weeks_active_hours?.detailed?.length >= 1 && (
                <p className="Normal Normal--Secondary Normal_Small Total_Time">
                    {`Vecka: ${weeks_active_hours.detailed} (${weeks_active_hours.overview} h)`}
                </p>
            )}
        </header>
    );
}
